var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lp-text text-border flex items-center justify-center\n      leading-tight font-serif italic text-yellow-400",attrs:{"title":_vm.display + ' life points'}},[_vm._v(" "+_vm._s(_vm.display)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }